import { commonrequest } from "./ApiCall";
import { BACKEND_URL } from "./helper";

export const registerfunction = async(data)=>{
    return await commonrequest("POST", `${BACKEND_URL}/register`, data)
}

export const loginfunction = async(data)=>{
    return await commonrequest("POST", `${BACKEND_URL}/login`, data)
}

export const getuserfunction = async(token)=>{
    return await commonrequest("GET", `${BACKEND_URL}/getuser`, token)
}

export const contactfunction = async(data)=>{
    return await commonrequest("GET", `${BACKEND_URL}/contact`, data)
}

export const messagefunction = async(data)=>{
    return await commonrequest("POST", `${BACKEND_URL}/message`, data)
}

export const logoutfunction = async(data)=>{
    return await commonrequest("GET", `${BACKEND_URL}/logout`, data)
}